import { makeRequest } from "./client";

export interface EmailPreference {
  email: string;
  context: "dashboard" | "app" | "transactional";
  unsubscribed: boolean;
  unsubscribedAt?: string;
  updatedAt: string;
}

export interface EmailPreferencesResponse {
  email: string;
  preferences: EmailPreference[];
}

export interface UpdateEmailPreferenceRequest {
  /** Optional; server uses email from the Bearer token only */
  email?: string;
  context: "dashboard" | "app";
  unsubscribed: boolean;
}

export const emailPreferencesApi = {
  getPreferences: async (token: string): Promise<EmailPreferencesResponse> => {
    return makeRequest("/v1/users/email-preferences", {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  updatePreference: async (
    data: UpdateEmailPreferenceRequest,
    token: string
  ): Promise<{ message: string; preference: EmailPreference }> => {
    return makeRequest("/v1/users/email-preferences", {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(data),
    });
  },
};
